import React from 'react';
import { useSiteData } from '../hooks/provider/SiteDataProvider';
import { FILE_URL } from '../constants';

function LeftContent() {
  const {siteData} = useSiteData();
  const SITE_LOGO = siteData?.site_logo || './assets/image/logo-bhajjamal.png';

  return (
    <div className="col-md-6 sticky-lg-top vh-100 d-grid align-content-center">
        <a href="/">
          <img className="mb-4" src={`${FILE_URL}${SITE_LOGO}`} width="169" height="auto" alt="Logo" />
        </a>
        <h4 className="text-start fw-bold" style={{ color: 'hsl(217, 10%, 50.8%)' }}>Sell Your Products with Bhajjamal</h4>
        <p className="text-start" style={{ color: 'hsl(217, 10%, 50.8%)' }}>
        With Bhajjamal, vendors can easily sell their products through a secure and efficient eCommerce platform. Bhajjamal provides a seamless experience for customers to browse and purchase your products directly from the comfort of their home.        </p>
        <h4 className="text-start fw-bold" style={{ color: 'hsl(217, 10%, 50.8%)' }}>How to Receive Orders on Bhajjamal?</h4>
        <p className="text-start" style={{ color: 'hsl(217, 10%, 50.8%)' }}>We’d love to onboard you with Bhajjamal. Once registered, you’ll receive a dedicated URL to showcase your products, making it easy for customers to place orders through our user-friendly platform.</p>
        <h4 className="text-start fw-bold" style={{ color: 'hsl(217, 10%, 50.8%)' }}>Vendor Registration and Login with Bhajjamal</h4>
        <p className="text-start" style={{ color: 'hsl(217, 10%, 50.8%)' }}>Get started by registering as a vendor on Bhajjamal, and gain access to a simple login system. You can manage your products, track sales, and engage with your customers effortlessly through our eCommerce platform.</p>
    </div>
  );
}

export default LeftContent;
